<div id="carruselSiga" class="carousel slide" data-ride="carousel" data-interval="3500" data-pause="false" style="border-radius: 16px; overflow: hidden; box-shadow: 0 4px 15px rgba(0,0,0,0.15);">

    <div class="carousel-inner">

        <!-- Slide 1 -->
        <div class="carousel-item active">
            <img class="d-block w-100" src="./assets/images/BIENVENIDA SIGA.png" alt="bienvenida">
        </div>

        <!-- Slide 2 (puedes cambiar la imagen o repetir si gustas) -->
        <!-- <div class="carousel-item">
            <img class="d-block w-100" src="./assets/images/BIENVENIDA SIGA.png" alt="slide">
        </div> -->

        <!-- Slide 3 -->
        <!-- <div class="carousel-item">
            <img class="d-block w-100" src="./assets/images/BIENVENIDA SIGA.png" alt="slide">
        </div> -->

    </div>



</div>
<BR>
<BR>
<BR>
<BR>
<BR>